import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  position: relative;
`

export const DropDownLibraryContainer = styled.div`
  position: absolute;
  top: -52px;
  right: 24px;
`

export const TableContainer = styled.div`
  height: 100%;
  overflow: scroll;
`

export const Table = styled.table`
  border-spacing: 0;
`

export const Thead = styled.thead`
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 2px 3px 0px rgba(0, 0, 0, 0.1);

  position: sticky;
  top: 0;
`

export const Tr = styled.tr`
  :nth-child(even) {
    background-color: rgba(223, 226, 234, 0.2);
  }
`

export const Th = styled.th`
  height: 36px;

  color: var(--foreground-neutral-faded, var(--foreground-neutral-faded, #4d5874));
  /* Body 3/Medium */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  background: var(--persistent-white, #fff);
`

export const TBody = styled.tbody``

export const Td = styled.td<{ disabled?: boolean }>`
  padding: 0px;
  margin: 0;
`

export const TdContent = styled.div`
  border-left: 0.75px solid var(--background-neutral-faded, #f3f4f6);

  box-sizing: border-box;
  padding: 8px;

  width: 88px;
  height: 72px;

  display: flex;
  align-items: center;

  :hover {
    div {
      display: flex;
    }
  }
`

export const AddTaskTemplateButton = styled.div<{ isActive?: boolean }>`
  cursor: pointer;
  user-select: none;

  display: ${({ isActive }) => (isActive ? 'flex' : 'none')};
  flex-direction: row;
  justify-content: center;
  align-items: center;

  border-radius: 8px;
  border: 1px solid var(--border-primary, #4d4be7);

  width: 72px;
  height: 56px;
`

export const AddTaskTemplateImg = styled.img``
